// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { specificationsStyles } from "@sc/Overrides/Widgets/ProductDetails/ProductDetailsSpecifications";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

specificationsStyles.specificationsAccordion = {
    headingLevel: 2,
    css: css`
        ${xScreen("lte", "md")} {
            margin-top: 44px;
        }
    `,
};

specificationsStyles.attributesWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    `,
};

specificationsStyles.specificationsAccordionSection = {
    panelProps: {
        css: css`
            ul {
                margin: 0;
                li:last-child {
                    margin-bottom: 0;
                }
            }
        `,
    },
};

specificationsStyles.attributeTypeWrapper = {
    css: css`
        width: 42%;
        border-bottom: 1px solid ${color("common.border")};
        display: flex;
        gap: 12px;
        padding-bottom: 8px;
        margin-bottom: 6px;
        &:last-child {
            border-bottom: none;
            padding-bottom: 0;
            margin-bottom: 0;
        }
        &:nth-last-child(-n + 2) {
            ${({ removeBorderForLastTwoItems }: any) =>
                removeBorderForLastTwoItems ? "border-bottom: none; padding-bottom: 0;margin-bottom: 0;" : ""}
        }
        ${xScreen("lte", 767)} {
            width: 100%;
            &&&:not(:last-child) {
                padding-bottom: 8px;
                margin-bottom: 6px;
                border-bottom: 1px solid ${color("common.border")};
            }
        }
    `,
};

specificationsStyles.attributeTypeLabelText = {
    lineHeight: "22px",
    weight: "bold",
    size: 14,
    css: css`
        width: calc(50% - 6px);
    `,
};

specificationsStyles.attributeTypeValuesText = {
    lineHeight: "22px",
    size: 14,
    css: css`
        width: calc(50% - 6px);
    `,
};
